import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { gcpAllAccountsGroupedByOrgsSelector } from "./gcpAllAccountsGroupedByOrgsSelector";
import { providerAllAccountsCombiner } from "../../combiners/providerAllAccountsCombiner";

export const gcpAllAccountsSelector = createDraftSafeSelector(
  [gcpAllAccountsGroupedByOrgsSelector],
  providerAllAccountsCombiner,
);
